import React, { Component } from 'react'

import { withTranslation } from 'react-i18next'

import { regionalChambersCommunicator } from '../../../../communicators/regionalChambersCommunicator'

import { RCPage } from '../../RCPage/RCPage'
import { RCSectionBlock } from '../../RCSectionBlock/RCSectionBlock'
import { RCContactSection } from './RCContactSection/RCContactSection'
import { RCSectionTitle } from '../../RCSectionTitle/RCSectionTitle'

class RCContact extends Component {
    constructor(props) {
        super(props)

        this.state = {
            contactDetails: '',
            mapAddress: '',
            isLoading: true
        }
    }

    componentDidMount() {
        this.loadChamber()
    }

    componentDidUpdate(prevProps) {
        if (this.props.slug !== prevProps.slug) {
            this.loadChamber()
        }
    }

    async loadChamber() {
        try {
            const { slug } = this.props
            const chamber = await regionalChambersCommunicator.fetchChamber(slug)

            this.setState({
                contactDetails: chamber.htmlContact,
                mapAddress: chamber.mapAddress,
                isLoading: false
            })
        } catch (error) {
            console.error(error)
            this.setState({
                isLoading: false
            })
        }
    }

    render() {
        const { contactDetails, mapAddress, isLoading } = this.state
        const { t, slug } = this.props

        const chamberInfo = t('chamberInfo')[slug]

        return (
            <RCPage
                isLoading={isLoading}
                title={`${chamberInfo.name}/${t('rcContact')}`}
                description={chamberInfo.about}
            >
                <RCSectionBlock withContainer>
                    <RCSectionTitle title={t('regionalChamber.contact.title')} />
                    <RCContactSection contactDetails={contactDetails} address={mapAddress} />
                </RCSectionBlock>
            </RCPage>
        )
    }
}

export default withTranslation()(RCContact)
